import React from 'react';
import { Root, Wrapper, Subheader, LogoWrapper, BorderBottom, Logo } from './styled';
import { useImageUrlBuilder } from 'hooks/useImageUrlBuilder';

interface MadadSubheaderProps {
  isVisible: boolean;
}

export const MadadSubheader: React.FC<MadadSubheaderProps> = ({ isVisible }) => {
  const constructImageURI = useImageUrlBuilder();

  return (
    <>
      <Root data-visible={isVisible}>
        <Wrapper>
          <Subheader />
          <LogoWrapper>
            <Logo width={176} src={constructImageURI('madad/2026/madadLogo.webp', { width: 352 })} />
          </LogoWrapper>
        </Wrapper>
      </Root>
      <BorderBottom />
    </>
  );
};
